import React, { Component } from 'react';

import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade } from 'react-bootstrap';

import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

import { AutoAffix } from 'react-overlays';

import MyCol from './MyCol';

export default class PanelContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <div>
                        <p>TEST</p>

                        <p>Talk to trees, look at the birds. Whatever it takes. We'll throw some old gray clouds in here just sneaking around and having fun. If you don't think every day is a good day - try missing a few. You'll see. Now we don't want him to get lonely, so we'll give him a little friend. You're meant to have fun in life. Let's make a nice big leafy tree.</p>

                        <p>We don't have to be committed. We are just playing here. Volunteering your time; it pays you and your whole community fantastic dividends. So often we avoid running water, and running water is a lot of fun.</p>

                        <p>Absolutely no pressure. You are just a whisper floating across a mountain. I'll go over the colors one more time that we use: Titanium white, Thalo green, Prussian blue, Van Dyke brown, Alizarin crimson, Sap green, Cad yellow, and Permanent red. Even trees need a friend. We all need friends. As trees get older they lose their chlorophyll. Follow the lay of the land. It's most important. When things happen - enjoy them. They're little gifts.</p>

                        <p>We have no limits to our world. We're only limited by our imagination. Just take out whatever you don't want. It'll change your entire perspective. Don't fight it, use what happens. Nothing's gonna make your husband or wife madder than coming home and having a snow-covered dinner. Maybe there's a happy little waterfall happening over here.</p>

                        <p>The more we do this - the more it will do good things to our heart. Let's build some happy little clouds up here. Very easy to work these to death. There are no mistakes. You can fix anything that happens. I guess I'm a little weird. I like to talk to trees and animals. That's okay though; I have more fun than most people.</p>

                        <p>And I will hypnotize that just a little bit. Trees grow however makes them happy. Every highlight needs it's own personal shadow. Let's give him a friend too. Everybody needs a friend.</p>

                        <p>You could sit here for weeks with your one hair brush trying to do that - or you could do it with one stroke with an almighty brush. This is probably the greatest thing that's ever happened in my life. This is truly an almighty mountain. We'll play with clouds today. Now, we're going to fluff this cloud. This is gonna be a happy little seascape.</p>
                    </div>

                      <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide More #1</AwesomeButton>
                    </div>
                  </div>


                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="QH2-TGUlwu4"
                      />
                    </div>

                    <div>
                      <AwesomeButtonSocial type="github" href="GITHUB_TODO">Source</AwesomeButtonSocial>
                      <AwesomeButton href="DOWNLOAD_TODO">Download</AwesomeButton>
                    </div>

                    <div className="screenshots-group">
                      <Image src="assets/screenshot-1.jpg" className="screenshot"/>
                      <Image src="assets/screenshot-2.jpg" className="screenshot"/>
                      <Image src="assets/screenshot-3.jpg" className="screenshot"/>
                    </div>
                  </div>

                </Panel.Body>


        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PanelContent.jsx